export enum LuggageType {
  Handluggage = "Handluggage",
  HandluggagePlusChecked = "HandluggagePlusChecked"
}
